// removed by extract-text-webpack-plugin
module.exports = {"Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-pc":"Accordion__title-pc","Accordion__title-mb":"Accordion__title-mb","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","Accordion__contents":"Accordion__contents","Accordion--enabled":"Accordion--enabled","simpleAnimation":"simpleAnimation","open":"open"};


//////////////////
// WEBPACK FOOTER
// ./src/components/accordion/styles.css
// module id = 693
// module chunks = 0 1